__turbopack_context__.v({
  "incompleteStrip": "InvestorPromptBanner-module-scss-module__pJ4v1W__incompleteStrip",
  "incompleteWarning": "InvestorPromptBanner-module-scss-module__pJ4v1W__incompleteWarning",
  "linkButton": "InvestorPromptBanner-module-scss-module__pJ4v1W__linkButton",
  "warningButtons": "InvestorPromptBanner-module-scss-module__pJ4v1W__warningButtons",
  "warningContent": "InvestorPromptBanner-module-scss-module__pJ4v1W__warningContent",
  "warningIcon": "InvestorPromptBanner-module-scss-module__pJ4v1W__warningIcon",
  "warningText": "InvestorPromptBanner-module-scss-module__pJ4v1W__warningText",
});
